import React, { useState, useEffect } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
// import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useHistory } from "react-router-dom";
import Settings from "../Settings";
import Nominee from "../../components/Nominee";
import Bank from "../Bank";
import { Button } from "@material-ui/core";
import Backicon from "../../assets/icons/backicon";
import Onboarding from "../Onboarding";
import ActivityLogs from "../ActivityLogs";
import queryString from "query-string";
import { Hidden } from "@material-ui/core";
import NotFoundPage from "../NotFoundPage";
import { useSelector, useDispatch } from "react-redux";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function AccountSettings(props) {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  const val = queryString.parse(props.location.search);
  const [value, setValue] = useState(val.tab ? val.tab : 0);

  const token = useSelector((state) => state.trading.TOKEN);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    if (val.tab) {
      setValue(Number(val.tab));
    } else setValue(0);
  }, [val.tab]);

  return (
    <>
      <div className={classes.root}>
        <div>
          <Button
            onClick={() => {
              dispatch({ type: "SET_ACC_POPUP", payload: true });
            }}
            disableRipple
            className="bg-transparent md:hidden  min-w-max p-0 mt-[-30px]   w-[30px] h-[30px]"
          >
            <Backicon />
          </Button>
        </div>
        <Hidden smDown>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            indicatorColor="primary"
          >
            <Tab
              label="Profile"
              {...a11yProps(0)}
              style={{ borderBottom: `1px solid ${theme.palette.divider}` }}
            />
            <Tab
              label="Bank Account"
              {...a11yProps(1)}
              style={{ borderBottom: `1px solid ${theme.palette.divider}` }}
            />
            <Tab
              label="Nominee"
              {...a11yProps(2)}
              style={{ borderBottom: `1px solid ${theme.palette.divider}` }}
            />
            <Tab
              label="Security"
              {...a11yProps(3)}
              style={{ borderBottom: `1px solid ${theme.palette.divider}` }}
            />
            <Tab
              label="Activity Logs"
              {...a11yProps(4)}
              style={{ borderBottom: `1px solid ${theme.palette.divider}` }}
            />
          </Tabs>
        </Hidden>
        <TabPanel value={value} index={0} className={classes.tabContent}>
          <Onboarding />
        </TabPanel>
        <TabPanel value={value} index={1} className={classes.tabContent}>
          <Bank />
        </TabPanel>
        <TabPanel value={value} index={2} className={classes.tabContent}>
          <Nominee />
        </TabPanel>
        <TabPanel value={value} index={3} className={classes.tabContent}>
          <Settings />
        </TabPanel>
        <TabPanel value={value} index={4} className={classes.tabContent}>
          <ActivityLogs />
        </TabPanel>
      </div>

      {/* <Hidden mdUp>
        <NotFoundPage link="/onboarding" />
      </Hidden> */}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.down("sm")]: {
      // minWidth: "450px",
      maxWidth: "450px",
    },
  },
  root: {
    flexGrow: 1,
    display: "flex",
    // height: 376,
    maxWidth: "1200px",
    // minWidth: "1200px",
    padding: "20px",
    // alignItems: "center",
    justifyContent: "center",
    margin: "auto",
    // [theme.breakpoints.up("md")]: {
    //   width: "50%",
    //   marginTop: "50px",
    // },
  },
  tabs: {
    // borderRight: `1px solid ${theme.palette.divider}`,
    background: theme.palette.type === "dark" ? "#151827" : "white",
    marginTop: "96px",
    marginRight: "45px",
    width: "260px",
    height: "240px",
    // this is for moving vertical tabs
    // position: "fixed !important",
    // left: "200px"
  },
  tabContent: {
    width: "100%",
  },
  topHeading: {
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.3rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2rem",
    },
  },
}));
